import { ResumeSensitiveDialog } from '@seek/profile-base-ui';
import { useTranslations } from '@vocab/react';
import { TextLinkButton } from 'braid-design-system';
import { useState } from 'react';

import { useConfig } from 'src/context/config';
import { Page, PageSection, useTrackingClient } from 'src/context/tracking';

import translations from './.vocab';

export const DocumentSensitive = () => {
  const [showDialog, setShowDialog] = useState(false);
  const { config } = useConfig();
  const client = useTrackingClient();
  const { t } = useTranslations(translations);

  const handleSpiClick = () => {
    client.trackLink({
      link: 'sensitive_information_dialog_displayed',
      eventName: 'sensitive_information_dialog_displayed',
      currentPage: Page.DOCUMENT_PAGE,
      currentPageSection: PageSection.DOCUMENTS,
    });

    setShowDialog(true);
  };

  const handleSpiLinkClick = () => {
    client.trackLink({
      link: 'sensitive_information_dialog_pressed',
      eventName: 'sensitive_information_dialog_pressed',
      currentPage: Page.DOCUMENT_PAGE,
      currentPageSection: PageSection.DOCUMENTS,
      linkText: 'sensitive Information: what you need to know',
    });
  };

  return (
    <>
      <ResumeSensitiveDialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        onTrackSensitiveInfoLink={() => handleSpiLinkClick()}
        zone={config.ZONE}
        language={config.LANGUAGE}
      />
      <>
        {t('Spi', {
          TextLinkButton: (v) => (
            <TextLinkButton onClick={handleSpiClick} weight="weak">
              {v}
            </TextLinkButton>
          ),
        })}
      </>
    </>
  );
};
